import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'

import {
  RadarChart
} from 'echarts/charts'

import {
  GridComponent,
  TooltipComponent  
} from 'echarts/components'

import { 
  CanvasRenderer,
  SVGRenderer
} from 'echarts/renderers'

export interface RadarData {
  label: string
  value: number
  min: number
  max: number
}

const BASE_RATE_PERCENT = 20

type InterestRadarProps = {
  list: RadarData[]
  animation?: boolean
  renderer?: 'canvas' | 'svg',
  width?: number | 'auto'
  height?: number | 'auto'
  radius?: number
  nameGap?: number
}
export const InterestRadar = ({
  list,
  animation,
  renderer,
  width,
  height,
  radius,
  nameGap
}: InterestRadarProps) => {
  echarts.use([
    TooltipComponent,
    GridComponent,
    RadarChart,
    renderer === 'svg' ? SVGRenderer : CanvasRenderer
  ])
  return (
    <ReactEChartsCore
      echarts={echarts}
      style={{
        height: 'auto'
      }}
      option={{
        animation: animation,
        radar: {
          indicator: list.map((r) => ({
            name: r.label,
            min: r.min,
            max: r.max * (1 + (BASE_RATE_PERCENT / 100)),
            color: r.value === 0 ? '#CCC' : undefined
          })),
          shape: 'circle',
          radius: radius ?? 70,
          axisNameGap: nameGap ?? 15
        },
        series: [{
          name: 'Interest',
          type: 'radar',
          data: [{
            value: list.map((r) => r.value + (r.max * (BASE_RATE_PERCENT / 100))),
            name: 'result',
            areaStyle: {
              color: 'rgba(255, 228, 52, 0.8)'
            }
          }]
        }],
        textStyle: {
          fontFamily: 'Noto Sans JP,sans-serif',
          color: '#000'
        }
      }}
      notMerge={true}
      opts={{
        renderer: renderer === 'svg' ? 'svg' : 'canvas',
        width: width,
        height: height
      }}
      theme="insite"
    />
  )
}